import api from "./base-api"

const clockmakerPlayerEventApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getPlayerEventsV1Cm: build.query({
            query: ({
                userId = "",
                from,
                to
            }) => `v1/clockmaker/player-events/${userId}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
            keepUnusedDataFor: 300
        })
    }),
    overrideExisting: false
})

export const {
    useGetPlayerEventsV1CmQuery
} = clockmakerPlayerEventApiV1
